import * as React from 'react';
import {useContext, useState} from 'react';
import {DefaultButton, Panel, PrimaryButton, Stack} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function AddTransactionInvoiceDocument(props) {
    const [user] = useContext(AuthContext);
    const [file, setFile] = useState(null);

    const _submit = (e) => {
        e.preventDefault();
        if (file !== null) {
            const data = new FormData();
            data.append('document', file);
            data.append('project_id', props.add.project_id);
            fetch(`/api/transaction/invoice/${props.add.id}/document`, {
                method: 'POST',
                body: data,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => {
                    props.onSuccess(json);
                    props.dismissPanel();
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddTransactionInvoiceDocument'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Plik Faktury"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddTransactionInvoiceDocument'>
                <br/>
                <input type="file" name="file" onChange={(e) => setFile(e.target.files[0])}/>
            </form>
        </Panel>
    )
}

export default AddTransactionInvoiceDocument;